x<template>
  <div class="coupon-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'customer_coupon_list' }" class="float-left mr-1 main-link">{{$t('coupon.customer_coupon')}}</router-link> / {{$t('coupon.detail')}}
                </h3>
              </strong>
            </div>

            <legend class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('coupon.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">

          <!-- Basic information -->
          <b-card header-tag="header" footer-tag="footer" class="header">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.basic_information') }}</strong>
                <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                  <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                  <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
                </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.parent_coupon')}}</legend>
                    <div class="col-sm-10">
                      <multiselect v-model="item.parentObj"
                        v-bind:placeholder="$t('coupon.parent_coupon')"
                        label="text" track-by="value"
                        @input="parentChange()"
                        :options="customCouponParentData"
                                   v-bind:selectLabel = "$t('menu.select_label')"
                                   v-bind:deselectLabel = "$t('menu.select_remove')"
                                   v-bind:selectedLabel = "$t('menu.selected')" 
                      />
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.child_coupon_code')}}</legend>
                    <div class="col-sm-10" >
                      <b-form-input class="form-control" v-model="item.code"
                        v-bind:placeholder="$t('coupon.child_coupon_code')" :state="!$v.item.code.$invalid"
                        aria-describedby="code-feedback"/>
                      <b-form-invalid-feedback :id="'coupon-code-feedback'">
                        <p class="help is-danger" v-if="!$v.item.code.required">{{ $t('message.required_filed') }}</p>
                        <p class="help is-danger" v-else-if="!$v.item.code.maxLength">{{ $t('coupon.coupon') }} {{ $t('coupon.coupon_max') }} {{$v.item.code.$params.maxLength.max}} {{ $t('coupon_character') }}.</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div>

                  <!-- <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.name')}}</legend>
                    <div v-for="lang in $store.getters.languages" class="col-sm-5" :key="lang.id" >
                      <b-form-input
                        v-model="item.name[lang]"
                        v-bind:placeholder="$t('common.text_'+lang)"
                        :change="updateCrmURL()"
                        :name="`name[${lang}]`" />
                    </div>
                  </div> -->

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.number_of_coupon')}}</legend>
                    <div class="col-sm-10" >
                      <b-form-input type="number"
                        class="form-control"
                        v-model="item.quantity"
                        v-bind:placeholder="$t('coupon.number_of_coupon')" :state="!$v.item.quantity.$invalid"
                        aria-describedby="number_of_coupon-feedback"/>
                    </div>
                  </div>
                 
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Basic information -->

          <!-- Time settings -->
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.time_settings') }}</strong>
              <label class="switch switch-sm switch-text switch-info float-right" @click="updateTimeSettingStatus"  v-b-toggle.time_settings_content>
                <i class="fa fa-sort-down" v-if="timeSettingStatus"></i>
                <i class="fa fa-sort-up" v-if="!timeSettingStatus"></i>
              </label>
            </div>
            <b-collapse :visible.sync="timeSettingStatus" id="time_settings_content">
              <b-form class="row">
                <b-col cols="12">

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.active_period')}}</legend>
                    <div class="col-sm-3">
                      <date-picker-input
                        className="form-control col-sm-5 float-left"
                        name="date"
                        type="date"
                        :value="item.active_start_date"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY"
                        formatOutput="DD-MM-YYYY"
                        :change="(e) => item.active_start_date = e"
                      />

                      <date-picker-input
                        className="form-control col-sm-5 float-left"
                        name="date"
                        type="date"
                        :value="item.active_end_date"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY"
                        formatOutput="DD-MM-YYYY"
                        :change="(e) => item.active_end_date = e"
                      />
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.applicable_period')}}</legend>
                    <div class="col-sm-3">
                      <date-picker-input
                        className="form-control col-sm-5 float-left"
                        name="date"
                        type="date"
                        :value="item.apply_start_date"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY"
                        formatOutput="DD-MM-YYYY"
                        :change="(e) => item.apply_start_date = e"
                      />

                      <date-picker-input
                        className="form-control col-sm-5 float-left"
                        name="date"
                        type="date"
                        :value="item.apply_end_date"
                        :hasPicker="true"
                        formatInput="DD-MM-YYYY"
                        formatOutput="DD-MM-YYYY"
                        :change="(e) => item.apply_end_date = e"
                      />
                    </div>
                  </div>

                  <!-- <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.crm_url')}}</legend>
                    <div class="col-sm-10" >
                      <b-form-input
                        class="form-control"
                        v-model="item.crm_url"
                        :readonly="true"
                        v-bind:placeholder="$t('coupon.crm_url')"/>
                    </div>
                  </div>

                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('coupon.applicable_active_date_for_user')}}</legend>
                    <div class="col-sm-2" style="display: inline-flex;">
                      <b-form-input type="number"
                        class="form-control"
                        v-model="item.applicable_active_date_for_user"/>
                        <span style="margin-left: 10px; margin-top: 5px">{{$t('coupon.day_s')}}</span>
                    </div>
                  </div> -->

                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Time settings -->

          <div slot="footer" class="card-footer">
            <router-link :to="{ name: 'coupon_external_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>
            <div class="btn-save">
              <b-button :disabled="$v.item.$invalid" variant="success" v-on:click="saveCoupon()">&nbsp; {{ $t('common.save')}}</b-button>
            </div>
          </div>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {required,requiredIf,maxLength,between } from 'vuelidate/lib/validators'
import cSwitch from '../../../components/Switch'
import MaskedInput from 'vue-text-mask'
import Multiselect from 'vue-multiselect'
import DatePickerInput from '@/components/Partials/DatePickerInput'

const VALIDATION_SUCCESS = 1
const VALIDATION_SEVERAL_FAILED = 2
const VALIDATION_ALL_FAILED = 3
let vm = null

export default {
  props: {
    id: {
      type: String,
      required: true,
      default: 'create'
    }
  },
  components: {
    MaskedInput,
    Multiselect,
    cSwitch,
    DatePickerInput
  },
  data: function () {
    return {
      clientID: localStorage.getItem('clientID'),
      itemLimit: 10000,
      couponParentData:{},
      customCouponParentData:[],
      isLoadingCouponParent: false,
      isLoadingCoupon: false,
      isProcessing: false,
      prefix_crm_url: this.$store.getters.config.main.base_site_url,
      item: {
        coupon_id: "",
        parentObj: "",
        code:"",
        // name:{},
        quantity:0,
        active:1,
        active_start_date:this.$moment().format('DD-MM-YYYY'),
        active_end_date:'31-12-9999',
        apply_start_date:this.$moment().format('DD-MM-YYYY'),
        apply_end_date:'31-12-9999',
        // crm_url: "",
        // applicable_active_date_for_user: 0
      },
      basicInformationStatus: true,
      timeSettingStatus: true,
      languages: Object.keys(this.$i18n.messages),
    }
  },
  mixins: [
    validationMixin
  ],
  validations: {
    item: {
      code: {
        required,
        maxLength: maxLength(50)
      },
      coupon_id:{
        required
      },
      quantity: {
        required,
        between: between(0, 999999999)
      }
    }
  },
  methods: {
    escapeRegExp (string) {
      return string.replace(/[-[\]{}()*+!<=:?.\/\\^$|#\s%,]/gm, '')
    },
    updateCrmURL () {
      vm.item.crm_url = vm.prefix_crm_url + '/crm/coupon/' + vm.item.code
    },
    parentChange () {
      if (vm.item.parentObj) {
        vm.item.coupon_id = vm.item.parentObj.value  
      } else {
        vm.item.coupon_id = vm.item.parentObj
      }
    },
    updateBasicInformationStatus () {
      this.basicInformationStatus = this.basicInformationStatus?false:true
    },
    updateTimeSettingStatus () {
      this.timeSettingStatus = this.timeSettingStatus?false:true
    },
    saveCoupon () {
      vm.$bus.$emit('loading', 'block')
      vm.isProcessing = true;
      if (vm.id == 'create' || vm.id == undefined) {
        vm.axios.coupon.createExternalCoupon(vm.item, function(response){
          vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
          vm.isProcessing = false
          vm.$router.push({name: 'coupon_external_list'})
        }, function(){
          vm.isProcessing = false
        });
      } else {
        vm.axios.coupon.updateExternalCoupon(vm.item, function(response){
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          vm.isProcessing = false
        }, function(){
          vm.isProcessing = false
        });
      }
      vm.$bus.$emit('loading', 'none')
    },
    revertDateFormat (val) {
      let formatDate = this.$moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD')
      return this.convertDateTimeToUTC(formatDate)
    },
    convertDateFormat (val) {
      val = this.convertUTCToClientTime(val)
      return this.$moment(val, 'YYYY-MM-DD').format('DD-MM-YYYY')
    },
    convertDateTimeFormat (val) {
      val = this.convertUTCToClientTime(val)
      return this.$moment(val, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss')
    },
    mappingCouponData(externalCoupon)
    {
      vm.item = externalCoupon
      if (vm.clientID=='606dd890-1e5d-4898-853a-0ef434fff627') {
        if (vm.item.customer_id) {
          let quantity = externalCoupon.number_of_generate + externalCoupon.number_of_useage
          if (quantity > 999999999) {
            quantity = 999999999
          }
          vm.item.quantity = externalCoupon.number_of_generate 
                              ? quantity
                              : externalCoupon.number_of_useage
        } else {
          vm.item.quantity = externalCoupon.number_of_generate ? externalCoupon.number_of_generate : externalCoupon.number_of_useage
        }
      } else {
        vm.item.quantity = externalCoupon.number_of_useage
      }
      vm.item.active_start_date=vm.convertDateFormat(externalCoupon.active_from)
      vm.item.active_end_date=vm.convertDateFormat(externalCoupon.active_to)
      vm.item.apply_start_date=vm.convertDateFormat(externalCoupon.apply_from)
      vm.item.apply_end_date=vm.convertDateFormat(externalCoupon.apply_to)

      // reload web coupon
      vm.item.parentObj={'text': externalCoupon.coupon.code, 'value': externalCoupon.coupon_id}
    },
    getExternalCouponDetail()
    {
      vm.isLoadingCoupon = true
      if(!vm.id) return

      //get coupon detail
      vm.axios.coupon.getExternalCouponDetail(vm.id, function(response){
        let externalCoupon=response.data.data.item
        vm.mappingCouponData(externalCoupon)

        vm.$bus.$emit('loading', 'none')
      }, function(error){
        vm.$bus.$emit('loading', 'none')
      })
    },
    getCouponParent () {
      let params = '';
      vm.isLoadingCouponParent = true
      vm.axios.coupon.getCouponParent(params, function(response){
        let langs = vm.languages
        for (let l in langs) {
          let lang = langs[l]
          vm.couponParentData[lang] = []
          for (let i in response.data.data.items) {
            let item = {}
            item['text'] = response.data.data.items[i].code
            item['value'] = response.data.data.items[i].id
            vm.couponParentData[lang].push(item)
          }
        }

        vm.$forceUpdate('couponParentData')
        vm.isLoadingCouponParent = false
        vm.$bus.$emit('loading', 'none')
      })
    }
  },
  created: function () {
    vm = this
    vm.$bus.$emit('loading', 'block')
    vm.getCouponParent()
  },
  updated: function () {
    if (vm.couponParentData[vm.$session.get('lang')]!==undefined) {
      vm.customCouponParentData = vm.couponParentData[vm.$session.get('lang')]
    }
    if (vm.id != 'create' && vm.id !== undefined
      && !vm.isLoadingCouponParent
      && !vm.isLoadingCoupon) {
      vm.getExternalCouponDetail()
    }
  },
  mounted: function(){
  }
}
</script>

<style>
  .coupon-form input,
  .coupon-form textarea,
  .coupon-form select,
  .coupon-form .multiselect__tags {
      border-radius: 4px !important;
  }

  .multiselect__tags{
      border-radius: 0 !important;
  }

  .coupon-form .btn-secondary{
    border-radius: 3px;
  }

  /*checkbox style*/
  .coupon-form  .form-check:after,
  .coupon-form .form-check:before {
      content: " ";
      display: table;
      content: "";
      line-height: 0;
  }

  .coupon-form .form-check input[type="checkbox"] {
      opacity: 0;
      z-index: 1;
      cursor: pointer;
  }

  .coupon-form .form-check label {
      min-height: 20px;
      padding-left: 15px;
      cursor: pointer;
      display: inline-block;
      max-width: 100%;
      margin-bottom: 5px;
      font-weight: normal;
      vertical-align: middle;
      position: relative;
  }

  .coupon-form .form-check label::before {
      border-radius: 50%;
      content: "";
      display: inline-block;
      position: absolute;
      width: 20px;
      height: 20px;
      left: 0;
      margin-left: -10px;
      border: 1px solid #cccccc;
      background-color: #fff;
      -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::before {
      background-color: #0086FF;
      border-color: #0086FF;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::after {
      font-family: 'FontAwesome';
      content: "\f00c";
      color: #fff;
  }

  .coupon-form .form-check label::after {
      display: inline-block;
      position: absolute;
      width: 16px;
      height: 16px;
      left: 0;
      top: 0;
      margin-left: -10px;
      padding-left: 4px;
      padding-top: 1px;
      font-size: 12px;
      color: #0086FF;
  }
  /*checkbox style*/
  .coupon-form #customize-field .col-sm-10
  {
    padding-left: 8px;
  }

  .coupon-form .form-check-inline{
    margin-right: 1rem;
  }

  .coupon-form .modal-lg{
    max-width: 95%;
    margin-top: 0;
  }

  .coupon-form .modal-body{
    padding: 0 1rem;
  }

  .coupon-form .padding-none{
    padding: 0;
  }

  .applicable-store label span{
    width: 48px;
  }

  .applicable-store select{
    margin-right: 20px;
  }

  .img-min-height {
    min-height: 0 !important;
  }

  /*.multiselect__tags{
    min-height: 35px !important;
    padding: 2px 15px 0px 10px !important;
  }

  .multiselect__select{
    height: 36px !important;
  }

  .multiselect__placeholder{
    margin-bottom: 5px !important;
    padding-top: 4px !important;
  }*/

  .multiselect__placeholder{
    margin-bottom: 6px !important;
  }

  .not_apply_date .mx-input-append {
    display: none!important;
  }
  .not_apply_date .mx-calendar {
    width: 400px!important;
  }
  .not_apply_date .mx-calendar-header {
    width: 100%!important;
  }
  .not_apply_date .mx-calendar-content {
    width : 100%!important;
    height: 100%!important;
  }
  .not_apply_date .mx-time-list{
    height: 225px;
  }

</style>

<style scoped>
  #application_result_content .gray-background{
    border-radius: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  #application_result_content .gray-light-background{
    border-radius: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  .payment-methods{
    padding: 0 !important;
  }

  .payment-methods .form-group{
    padding: 10px 15px 0 15px;
    margin-bottom: 5px;
  }

  .payment-methods .form-group:last-child{
    margin-bottom: 15px;
  }

  .payment-methods .form-check{
    margin-left: 15px;
  }

  .business-hours .form-check{
    padding-right: 15px;
  }

  .business-hours{
    display: inline-flex;
    vertical-align: middle;
  }

  .size-circle{
    margin-left: 5px;
  }

  .sl-discount-unit,
  .ipt-discount-unit{
    min-height: 40px;
  }

  .delete-csv{
    background: transparent;
    color: #0086FF;
    border: none;
    font-size: 20px;
  }

  /*input file */
  .file-select > .select-button {
    padding: 7px;
    color: white;
    border-radius: .2rem;
    text-align: center;
    font-weight: bold;
    background: #0086FF !important;
    border-color: #0086FF !important;
    cursor: pointer;
    margin-top: 3px;
  }

  .file-select > input[type="file"] {
    display: none;
  }
  /*input file*/

  .applicable-store{
    display: inline-flex;
  }

  /*.applicable-store label{
    margin-right: 20px;
  }*/

  .applicable-store input{
    margin-top: 5px;
  }

  .switch-custom{
    max-width: 5.3%;
  }

  .table-bordered{
    margin-top: 10px;
  }

  .table-bordered thead{
    background-color: #E1E6EB;
  }

  .table-bordered tbody{
    background-color: #F4F6F8;
  }

  .table-bordered th{
    border: none;
  }

  .table-bordered .center{
    text-align: center;
  }

  .col-sm-2-custom{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
  }

  .col-sm-2-custom-display-inline{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
    display: inline-flex;
  }

  .coupon-form .btn-save{
    float: right;
    margin-right: 22px;
  }

  .coupon-form .switch.switch-icon{
    margin-top: 5px;
  }

  .coupon-form .header-custom{
    margin-top: 15px;
  }

  .coupon-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .coupon-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .coupon-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .coupon-form .header-custom-switch .active{
    float: right;
  }

  .coupon-form div.header,
  .coupon-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .coupon-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .coupon-form .add-more{
    padding-left: 0;
  }

  .gray-background .form-control{
    /*padding: 8px;*/
    border: 1px solid gray;
  }

  .gray-background{
    background: #E1E6EB;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-light-background{
    background: #F4F6F8;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-background .row{
    margin-bottom: 0px;
  }

  .remark .btn-danger{
    margin-top: 7px;
    background-color: #fff;
  }

  .gray-light-background .btn-danger,
  .table-bordered .btn-danger{
    background-color: #F4F6F8;
  }

  .table-bordered .btn-danger{
    margin-top: 4px;
  }

  .gray-background .btn-danger{
    background-color: #E1E6EB;
  }

  .gray-background .btn-danger .fa,
  .gray-light-background .btn-danger .fa,
  .remark .btn-danger .fa,
  .table-bordered .btn-danger .fa{
    color: #0086FF;
    font-size: 20px;
  }

  .gray-background .col-sm-10,
  .gray-light-background .col-sm-10,
  .gray-light-background .col-sm-5{
    padding-left: 5px;
  }

  .margin-top20{
    margin-top: 20px;
  }

  .margin-bottom10{
    margin-bottom: 10px;
  }

  .clear-both{
    margin-bottom: 15px;
  }

  .card{
    margin-bottom: 0;
  }

  .coupon-image{
    margin: 0;
    padding: 0;
    display: inline-flex;
  }

  .coupon-properties{
    display: -webkit-inline-box;
    position: relative;
    margin: 0;
    padding: 0;
  }

  .coupon-image img{
    width: 100%;
  }

  .coupon-properties legend{
    width: auto;
    resize: both;
  }

  .coupon-properties .check-is-member{
    max-width: 16%;
  }

  .preview-image {
    width: 100%;
  }

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/coupon/CustomerBaseForm.vue